import { CharacterLicense } from '~/shared';

export const licenseCategories: Record<
	CharacterLicense,
	{ name: string; letter: string }
> = {
	[CharacterLicense.DrivingBike]: {
		name: 'Мотоциклетный транспорт',
		letter: 'A',
	},
	[CharacterLicense.DrivingCar]: { name: 'Легковой транспорт', letter: 'B' },
	[CharacterLicense.DrivingTruck]: { name: 'Грузовой транспорт', letter: 'C' },
	[CharacterLicense.DrivingBus]: {
		name: 'Пассажирский транспорт',
		letter: 'D',
	},
	[CharacterLicense.Sailing]: { name: 'Водный транспорт', letter: 'S' },
	[CharacterLicense.Flying]: { name: 'Воздушный транспорт', letter: 'F' },
};
